function waitForCustomerReferralLoaded(a, b = 100) {
  const c = setInterval(function () {
    "undefined" != typeof uppromoteCustomerReferral && (a(), clearInterval(c));
  }, b);
  setTimeout(function () {
    clearInterval(c);
  }, 5e3);
}
function waitElementLoaded(a, b, c = 100) {
  const d = setInterval(function () {
    const c = document.querySelector(a);
    c && (b(), clearInterval(d));
  }, c);
  setTimeout(function () {
    clearInterval(d);
  }, 5e3);
}
const customerReferralItemSelector = `button.sca_aff_customer_refer_invite_button`;

waitElementLoaded(customerReferralItemSelector, function () {
  waitForCustomerReferralLoaded(function () {
    const button = document.querySelector(customerReferralItemSelector);
    if (button) {
      button.style.padding = "10px";
    }
  });
});